import gql from 'graphql-tag'

export const COMMENTS = gql`
  query SurveyForm($surveyId: Int!) {
    surveyForm(surveyId: $surveyId) {
      allDimensions {
        id
        name
      }

      allTopics {
        id
        name
        subtopics {
          id
          name
        }
      }

      allSectors {
        id
        b3Name
      }
    }

    subtopicsPerSectors(surveyId: $surveyId) {
      sectorId
      tagId
    }
  }
`
export const SURVEY_FORM = gql`
  query SurveyForm($surveyId: Int!) {
    surveyForm(surveyId: $surveyId) {
      allDimensions {
        id
        name
      }

      allTopics {
        id
        name
        subtopics {
          id
          name
        }
      }

      allSectors {
        id
        b3Name
      }
    }

    subtopicsPerSectors(surveyId: $surveyId) {
      sectorId
      tagId
      sector {
        b3Name
        id
      }
      tag {
        id
        name
        type
      }
    }
  }
`

